import React, { useEffect, useState } from 'react';
import classnames from 'classnames';

import styles from './ImageModal.module.scss';
import Modal, { ModalProps } from '../Modal';

export type ImageModalProps = Omit<ModalProps, 'close' | 'isVisible'> & {
  description: string | null;
  imageCssClass?: string | null;
  url: string;
};

export type OpenImageModalType = ImageModalProps & {
  resolve: (value?: any) => void;
  reject: (reason?: any) => void;
};

export type OpenImageModalListenerType = (args: OpenImageModalType) => void;

let listener: OpenImageModalListenerType | null = null;

export type OnCloseImageModalCallbackCallback = () => void;

const setListener = (callback: OpenImageModalListenerType) => {
  listener = callback;
  return removeListener;
};

const removeListener = () => {
  listener = null;
};

export const openImageModal = ({ title, btnClose, description, cssClass, imageCssClass, url }: ImageModalProps) =>
  new Promise((resolve, reject) => {
    listener &&
      listener({
        title,
        btnClose,
        description,
        url,
        cssClass,
        imageCssClass,
        resolve,
        reject,
      });
  });

const ImageModal: React.FC = () => {
  const [title, setTitle] = useState<string | null>(null);
  const [btnClose, setBtnClose] = useState<string | null>(null);
  const [description, setDescription] = useState<string | null>(null);
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [cssClass, setCssClass] = useState<string | null>(null);
  const [imageCssClass, setImageCssClass] = useState<string | null>(null);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [closeModal, setCloseModal] = useState<OnCloseImageModalCallbackCallback>(() => {});

  const onUnMount = setListener(async ({ title, btnClose, description, url, cssClass, imageCssClass, resolve }: OpenImageModalType) => {
    setIsVisible(true);
    setTitle(title);
    setDescription(description);
    setBtnClose(btnClose);
    setImageUrl(url);
    setCssClass(cssClass || null);
    setImageCssClass(imageCssClass || null);
    const close = () => {
      setIsVisible(false);
      resolve();
    };
    setCloseModal(() => close);
  });

  useEffect(() => {
    return () => {
      onUnMount();
    };
  }, [onUnMount]);

  return (
    <Modal title={title || ''} btnClose={btnClose} isVisible={isVisible} cssClass={cssClass} close={closeModal}>
      <div data-testid='image-modal' className={styles.ff_image_modal__content}>
        {imageUrl && (
          <div className={styles.ff_image_modal__img__container}>
            <div
              className={classnames(styles.ff_image_modal__img, {
                [imageCssClass || '']: !!imageCssClass,
              })}
              style={{ backgroundImage: `url(${imageUrl})` }}
            ></div>
          </div>
        )}
        {description && <div className={styles.ff_image_modal__description}>{description}</div>}
      </div>
    </Modal>
  );
};

export default ImageModal;
